import { createTheme, responsiveFontSizes } from '@mui/material/styles';

// Define your color palettes for light and dark modes
const lightPalette = {
    primary: {
        main: '#2979ff', // A vibrant blue
    },
    secondary: {
        main: '#ff6d00', // A warm orange
    },
    background: {
        default: '#f4f6f8',
        paper: '#ffffff',
    },
    text: {
        primary: '#212121',
        secondary: '#757575',
    },
};

const darkPalette = {
  primary: {
    main: '#00e5ff', // Neon Cyan
    contrastText: '#000000',
  },
  secondary: {
    main: '#ff3d00', // Deep Orange A400
    contrastText: '#ffffff',
  },
  background: {
    default: '#121212', // A deep, dark grey
    paper: '#1e1e1e',   // A slightly lighter grey for surfaces
  },
  text: {
    primary: '#e0e0e0',
    secondary: 'rgba(255, 255, 255, 0.7)',
  },
};

// A function to create the theme based on the mode
const getTheme = (mode) =>
    responsiveFontSizes(
        createTheme({
            palette: {
                mode,
                ...(mode === 'light' ? lightPalette : darkPalette),
            },
            typography: {
                fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
                h1: { fontWeight: 700 },
                h2: { fontWeight: 700 },
                h3: { fontWeight: 700 },
                h4: { fontWeight: 600 },
                h5: { fontWeight: 600 },
                h6: { fontWeight: 600 },
            },
            shape: {
                borderRadius: 12, // Slightly more rounded corners
            },
            components: {
                MuiAppBar: {
                    styleOverrides: {
                        root: ({ theme }) => ({
                            elevation: 0,
                            ...(theme.palette.mode === 'dark' && {
                                backgroundColor: theme.palette.background.paper,
                                borderBottom: `1px solid ${theme.palette.divider}`,
                            }),
                        }),
                    },
                },
                MuiButton: {
                    styleOverrides: {
                        root: {
                            textTransform: 'none',
                            fontWeight: 600,
                        },
                        containedPrimary: ({ theme }) => ({
                            ...(theme.palette.mode === 'dark' && {
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    boxShadow: `0 0 15px ${theme.palette.primary.main}`,
                                    backgroundColor: theme.palette.primary.main,
                                },
                            }),
                        }),
                    },
                },
                MuiCard: {
                    styleOverrides: {
                        root: ({ theme }) => ({
                            border: '1px solid transparent',
                            ...(theme.palette.mode === 'dark' && {
                                borderColor: theme.palette.divider,
                            }),
                        }),
                    },
                },
            }
        }),
    );

export default getTheme;
